import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// redux
import { Provider } from 'react-redux';
import store from './redux/store';

const DOMNode = document.getElementById('bostik-chatbot');

// get the token passed by attribute on this div
const TOKEN = DOMNode.getAttribute('data-token');
// console.log('Token on #bostik-chatbot',{token:TOKEN});

const root = ReactDOM.createRoot(DOMNode);
root.render(
  <Provider store={store}>
    <App token={TOKEN}/>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
